<template>
  <div class="invoices-filters">
    <snow-select
      id="product-select"
      label="Produto"
      v-model="form.product_id"
      :options="productOptions"
    />
    <snow-checkboxes-dropdown
      id="status-select"
      placeholder="Status"
      v-model="form.status"
      :options="statusOptions"
    />
    <snow-date-picker
      size="lg"
      label="Período de emissão"
      v-model="sendDates"
    />
    <snow-date-picker
      size="lg"
      label="Período de pagamento"
      class="mb-3"
      v-model="paymentDates"
    />
    <div class="snow-submit-buttons">
      <snow-button
        size="lg"
        class="order-lg-0 order-1"
        variant="gray"
        text="Cancelar"
        @click="$emit('close')"
      />
      <snow-button size="lg" text="Aplicar" @click="apply" />
    </div>
  </div>
</template>
<script>
import { clearObject, formFields } from "@/functions/helpers";
import { mapState } from "vuex";
export default {
  props: {
    value: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      sendDates:
        this.value && this.value.send_at_after && this.value.send_at_before
          ? [this.value.send_at_after, this.value.send_at_before]
          : [],
      paymentDates:
        this.value && this.value.paid_at_after && this.value.paid_at_before
          ? [this.value.paid_at_after, this.value.paid_at_before]
          : [],
      ...formFields(
        [
          "product_id",
          "status",
          "send_at_after",
          "send_at_before",
          "paid_at_after",
          "paid_at_before"
        ],
        { ...this.value }
      )
    };
  },
  watch: {
    sendDates(dates) {
      if (dates && dates.length === 2) {
        this.form.send_at_after = dates[0];
        this.form.send_at_before = dates[1];
      } else {
        this.form.send_at_after = null;
        this.form.send_at_before = null;
      }
    },
    paymentDates(dates) {
      if (dates && dates.length === 2) {
        this.form.paid_at_after = dates[0];
        this.form.paid_at_before = dates[1];
      } else {
        this.form.paid_at_after = null;
        this.form.paid_at_before = null;
      }
    }
  },
  computed: {
    ...mapState("product", ["products"]),
    productOptions() {
      return [{ id: "", name: "Todos os produtos" }, ...this.products];
    },
    statusOptions() {
      return [
        { id: "sent", label: "Enviado" },
        { id: "pending", label: "Pendente" },
        { id: "failed", label: "Falha" },
        { id: "canceled", label: "Cancelado" }
      ];
    }
  },
  methods: {
    apply() {
      this.$emit("input", clearObject(this.form));
      this.$emit("onFiltersApply");
    }
  },
  mounted() {
    this.$store.dispatch("product/get");
  }
};
</script>
<style lang="scss" scoped>
.invoices-filters {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
</style>
